import React from 'react';
import { ToastContainer } from 'react-toastify';
import AdminSidebar from 'admin/sidebar/AdminSidebar';
import './SuperAdminPackages.css';
import PackageOrdersPage from 'admin/components/pakagesOrder/PakagesOrder';

const PackageOrders = () => (
  <div className="mainDiv-all-sideBar">
    <div className="div-sidebar"><AdminSidebar /></div>
    <div className="div-Dashbaord" style={{ background: 'white', padding: 0 }}>
      <PackageOrdersPage />
    </div>
    <ToastContainer position="bottom-right" />
  </div>
);

export default PackageOrders;
